require('./brokerAlertConfigConfirmDelete.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @utils
const { FormattedText } = require('core/i18n').i18n;
const { getPreConditionText } = require('utilities/brokerAlertsConditionTextHelper');

// @component
const OKModal = require('components/commons/OKModal/OKModal');

// @constants
const {
    IBEX35_TEXT,
    BROKER_ALERT_PERCENTAGE_CONDITIONS_IDS,
    BROKER_ALERT_CONFIGURATION_POINTS_NAME,
    EURO_SYMBOL
} = require('constants/index');

class BrokerAlertConfigConfirmDelete extends React.Component {
    constructor(props) {
        super(props);

        this.handleConfirmedDelete = this.handleConfirmedDelete.bind(this);
        this.handleCancelDeleteCustomAlert = this.handleCancelDeleteCustomAlert.bind(this);
    }

    getConditionText(alertItem) {
        const isConfigIbex35 = alertItem.get('instrument') === IBEX35_TEXT;
        const text = getPreConditionText(alertItem.get('conditionId'), isConfigIbex35);
        const conditionRegEx = /\((.+)\)/;

        if ( BROKER_ALERT_PERCENTAGE_CONDITIONS_IDS.indexOf(alertItem.get('conditionId')) !== -1 ){
            return text.replace(conditionRegEx, "(" + alertItem.get('conditionValue') + '%' + ")");
        } else if(isConfigIbex35) {
            return text.replace(conditionRegEx, "(" + alertItem.get('conditionValue') + ' ' + BROKER_ALERT_CONFIGURATION_POINTS_NAME + ")");
        } else {
            return text.replace(conditionRegEx, "(" + alertItem.get('conditionValue') + ' ' + EURO_SYMBOL + ")");
        }
    }

    buildModalDeleteConfirmation() {
        const modalContent = (
            <React.Fragment>
                <div className="broker-alerts-config-confirm-delete__modal-subtitle">
                    <FormattedText value="broker-confirmDeleteAlertText1" />
                </div>
                <div className="broker-alerts-config-confirm-delete__modal-text">
                    <FormattedText value="broker-confirmDeleteAlertValue" />
                    <span className="broker-alerts-config-confirm-delete__modal-value">
                        {this.props.immItem.get('instrument')}
                    </span>
                </div>
                <div className="broker-alerts-config-confirm-delete__modal-text">
                    <FormattedText value="broker-confirmDeleteAlertCondition" />
                    <span className="broker-alerts-config-confirm-delete__modal-value">
                        {this.getConditionText(this.props.immItem)}
                    </span>
                </div>
            </React.Fragment>
        );

        if (this.props.immItem) {
            return (
                <OKModal
                    content={modalContent}
                    footerType="navigation"
                    isOpen={true}
                    onCloseCallback={this.handleCancelDeleteCustomAlert}
                    onPrimaryButtonClick={this.handleConfirmedDelete}
                    onSecondaryButtonClick={this.handleCancelDeleteCustomAlert}
                    primaryButtonText="broker-confirmDeleteAlertConfirm"
                    secondaryButtonText="broker-confirmDeleteAlertCancel"
                    title="broker-confirmDeleteAlertTitle"
                />
            );
        }
    }

    handleCancelDeleteCustomAlert() {
        this.props.onCancelDeleteAlert();
    }

    handleConfirmedDelete(alert) {
        this.props.onDeleteAlert(alert);
    }

    render() {
        return this.buildModalDeleteConfirmation();
    }

}


BrokerAlertConfigConfirmDelete.propTypes = {
    immItem: PropTypes.object.isRequired,
    onDeleteAlert: PropTypes.func.isRequired,
    onCancelDeleteAlert: PropTypes.func.isRequired
};

module.exports = BrokerAlertConfigConfirmDelete;
